import Resource from '@/api/resources/Resource'

class PriorityConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/priorities`, filterModel, { params })
        return response.data
    }
    async getPrioritiesByName(params) {
        const response = await this.axios.get(`/configuration/priorities/search`, { params })
        return response.data
    }
    async patchPrioritiesBatch(priorities) {
        const response = await this.axios.patch(`/configuration/priorities/batch`, priorities)
        return response.data
    }
    async createPriority(priority) {
        const response = await this.axios.post(`/configuration/priorities`, priority)
        return response.data
    }
    async deletePrioritiesBatch(priorities) {
        const data = {
            entityIdentifiers: priorities
        }
        const response = await this.axios.delete(`/configuration/priorities/batch`, { data: data })
        return response.data
    }
}

export default new PriorityConfigurationServices()
